import { formatIeComplaintDateTime } from "./ieComplaintUtils";

export const IE_COMPLAINT_EXPORT_COLUMNS = [
  "S.No",
  "Complaint No",
  "Complianant Contact No",
  "KPI Category",
  "Issue Type",
  "Description",
  "Zone",
  "Ward",
  "Location",
  "Complaint Created On",
  "Complaint Closure On",
  "Actual Duration (HH:MM)",
  "Colony Name",
  "Status",
  "Mode Of Reporting",
  "Action Remarks",
];

export const IE_COMPLAINT_HISTORY_COLUMNS = [
  "S.No",
  "Action Taken By",
  "Status",
  "Action Remarks",
  "Assigned On",
  "Action Taken On",
];

export const mapComplaintRowsForExport = (complaintData = []) =>
  (complaintData ?? []).map((row, index) => [
    index + 1,
    row.complainantNo || "N/A",
    row.contactNo || "N/A",
    row.kpiCategory || "N/A",
    row.issueType || "N/A",
    row.description || "N/A",
    row.zoneName || "N/A",
    row.wardNo || "N/A",
    row.location || "N/A",
    formatIeComplaintDateTime(row.complaintCreatedOn),
    formatIeComplaintDateTime(row.complaintClosureOn),
    row.actualDuration || "N/A",
    row.colonyName || "N/A",
    row.status || "N/A",
    row.modeOfReporting || "N/A",
    row.actionRemarks || "N/A",
  ]);

export const getHistoryForRow = (row, historyById = {}) => {
  const id = row?.complaintId;
  if (id && historyById[id]?.length) return historyById[id];
  if (row?.actionHistory?.length) return row.actionHistory;
  return [];
};

export const mapHistoryRowsForExport = (history = []) =>
  history.map((item, index) => [
    item.sNo ?? index + 1,
    item.actionTakenBy || "N/A",
    item.status || "N/A",
    item.actionRemarks || "N/A",
    formatIeComplaintDateTime(item.assignedOn),
    formatIeComplaintDateTime(item.actionTakenOn),
  ]);

export const loadAllIeComplaintHistory = async (complaintData = [], fetchActionHistory) => {
  const historyById = {};

  await Promise.all(
    complaintData.map(async (row) => {
      const id = row?.complaintId;
      if (!id) return;

      try {
        const result = await fetchActionHistory(id, row.complainantNo);
        const history = result?.data ?? (Array.isArray(result) ? result : []);
        historyById[id] = history?.length ? history : row.actionHistory || [];
      } catch {
        historyById[id] = row.actionHistory || [];
      }
    })
  );

  return historyById;
};

export const getExportDateTime = () => {
  const now = new Date();
  const date = `${now.getDate()}-${now.getMonth() + 1}-${now.getFullYear()}`;
  const time = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
  return `IE Complaint List Generated on: ${date}, ${time}`;
};
